import { useSelector } from 'react-redux';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import { getLocaleData } from '@/selectors/localeSelectors';
import { getMycaApiUrl } from '@/selectors/mycaSelectors';
import { Card } from '@/constants';
import { useSelectedProductFromUserWallet } from '../memberHooks';

const badgeStatuses = {
  enrolled: 'success',
  notEnrolled: 'information',
  pending: 'neutral',
};

export const enrollmentStatuses = {
  ENROLLED: 'enrolled',
  NOT_ENROLLED: 'notEnrolled',
  PENDING: 'pending',
};

export const usePriorityPassEnrollmentDetails = () => {
  const { product } = useRouteParams();
  const {
    priorityPass,
    config: { features = [] },
  } = useCommonContent();
  const { locale } = useSelector(getLocaleData);
  const userProduct = useSelectedProductFromUserWallet(product, locale);
  const priorityPassFeature = features.find(
    (feat) => feat.name === 'priorityPass'
  );
  const enabled = priorityPassFeature?.enabled;
  const isStatusEnabledMarket =
    priorityPassFeature?.statusEnabledMarkets?.includes(
      userProduct?.homeCountryLocale?.toLowerCase()
    ) ?? false;
  const status =
    (isStatusEnabledMarket &&
      enrollmentStatuses[userProduct?.priorityPassStatus]) ||
    enrollmentStatuses.NOT_ENROLLED;
  const content = priorityPass[status] || priorityPass?.notEnrolled;
  const badge = badgeStatuses[status] || badgeStatuses.notEnrolled;

  return {
    enabled,
    isStatusEnabledMarket,
    status,
    badge,
    content,
  };
};

export const usePriorityPassEnrollmentUrl = () => {
  const { locale, product } = useRouteParams();
  const mycaApiUrl = useSelector(getMycaApiUrl);
  const userProduct = useSelectedProductFromUserWallet(product, locale);
  const lfProduct = userProduct?.loungeFinderProduct;
  const loungeCollection =
    lfProduct === Card.Centurion
      ? 'global-lounge-collection'
      : 'the-lounge-collection';
  const type = lfProduct === Card.Centurion ? 'centurion' : 'platinum';

  return `${mycaApiUrl}/card-benefits/enroll/${loungeCollection}/${type}`;
};
